import { singleton, length, map, isEmpty } from "../../../fable_modules/fable-library-js.4.19.0/List.js";
import * as react from "react";
import { HTMLAttr } from "../../../fable_modules/Fable.React.9.4.0/Fable.React.Props.fs.js";
import { keyValueList } from "../../../fable_modules/fable-library-js.4.19.0/MapUtil.js";

export function mobileDataList(messageEmpty, mapping, data) {
    if (isEmpty(data)) {
        return react.createElement("div", {
            className: "has-text-centered is-hidden-desktop",
        }, messageEmpty);
    }
    else {
        const children_10 = map((row) => {
            const children_8 = map((tupledArg) => {
                let children_4;
                const children_6 = [react.createElement("label", {}, tupledArg[0]), (children_4 = [tupledArg[1](row)], react.createElement("div", {}, ...children_4))];
                return react.createElement("div", {
                    className: "data-set",
                }, ...children_6);
            }, mapping);
            return react.createElement("div", {
                className: "data-item",
            }, ...children_8);
        }, data);
        return react.createElement("div", {
            className: "data-list is-hidden-desktop",
        }, ...children_10);
    }
}

export function desktopDataTable(messageEmpty, mapping, data) {
    let children_4, children_2, children_14, children_8, props_6;
    const children_16 = [(children_4 = [(children_2 = map((tupledArg) => react.createElement("th", {}, tupledArg[0]), mapping), react.createElement("tr", {}, ...children_2))], react.createElement("thead", {}, ...children_4)), (children_14 = (isEmpty(data) ? singleton((children_8 = [(props_6 = [new HTMLAttr(67, [length(mapping)]), new HTMLAttr(65, ["has-text-centered"])], react.createElement("td", keyValueList(props_6, 1), messageEmpty))], react.createElement("tr", {}, ...children_8))) : map((row) => {
        const children_12 = map((tupledArg_1) => {
            const children_10 = [tupledArg_1[1](row)];
            return react.createElement("td", {}, ...children_10);
        }, mapping);
        return react.createElement("tr", {}, ...children_12);
    }, data)), react.createElement("tbody", {}, ...children_14))];
    return react.createElement("table", {
        className: "table table-striped responsive-table is-hidden-touch is-bfscolored",
    }, ...children_16);
}

//# sourceMappingURL=DataList.fs.js.map
